export default "__VITE_ASSET__BxmvP3OS__"